import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class EmployeeSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "employeeId",
        label: "Employee Id",
        type: "text",
        placeholder: "Employee ID",
      },
      {
        name: "name",
        label: "Employee Name",
        type: "text",
        placeholder: "Employee Name",
      },
      {
        name: "role",
        label: "Role",
        type: "select",
        options: [],
        placeholder: "Role",
      },
    ];
    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  updatefields() {
    let result = this.fields.map((field) => {
      if (field.name === "role") {
        field.options = this.props.roles.options("role");
      }
    });
    return result;
  }
  render() {
    let { isAdmin } = this;
    let { openDrawer } = this.state;
    this.updatefields();
    return (
      <div className="d-flex align-items-center justify-content-end">
        {isAdmin && (
          <div className="action_btn_group text-end">
            <button
              type="button"
              className="btn btn-primary-transparent file_download_btn text-primary"
              onClick={(...args) => this.props?.downloadExcel(...args)}
            >
              <i className="fa fa-download me-2"></i>
              Download Excel
            </button>
          </div>
        )}
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
        <button
          className="btn btn-primary ms-1"
          onClick={(...args) => this.props?.addModalFields(...args)}
        >
          + Add Employee
        </button>
      </div>
    );
  }
}

export default constore(EmployeeSearch);
